import { gql } from '@apollo/client';

export const SEND_CONTACT_MESSAGE = gql`
  mutation SendContactMessage($contactMessageInput: ContactMessageInput!) {
    sendContactMessage(contactMessageInput: $contactMessageInput)
  }
`;
